import { RowStyle } from 'ag-grid-community';

export const getRowStyle = (params: any): RowStyle => {
  const { data } = params;
  if (!data) return {};

  // If a specific line color is provided (primarily used in the pivot manager), apply it.
  if (data.line_color) {
    return {
      backgroundColor: data.line_color.bgcolor || '',
      color: data.line_color.color || '',
    };
  }

  // Mapping of data sources to background colors.
  const sourceColorList: Record<string, string> = {
    Predicted: '#FDF3F3',
    'Looked up': '#F5F5DD',
    'From BOM': '#D0F5F5'
  };

  if (data.data_source && sourceColorList[data.data_source]) {
    return { backgroundColor: sourceColorList[data.data_source] };
  }

  // Apply special styling for rows representing "Total for this product".
  if (!data.data_type && data.name === 'Total for this product') {
    return {
      color: '#42454B',
      backgroundColor: '#D9DADB'
    };
  }

  // Styling for costable rows with process-related data types.
  if (data.costable && (data.data_type === 'process' || data.data_type === 'process_parent')) {
    return { backgroundColor: '#F9F9F9' };
  }

  return {};
};
